import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames, UitkContextWrapper } from 'uitk-react-utils';
import { UitkButton } from './uitk-button.esm.js';

var UitkSecondaryButton = /** @class */ (function (_super) {
    __extends(UitkSecondaryButton, _super);
    function UitkSecondaryButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkSecondaryButton.prototype.render = function () {
        var _a;
        var _b = this.props, inverse = _b.inverse, props = __rest(_b, ["inverse"]);
        var cssClassNames = classNames("".concat(UitkButton.baseClassName, "-secondary"), (_a = {},
            _a["".concat(UitkButton.baseClassName, "-secondary-inverse")] = inverse,
            _a), props.className);
        return (React.createElement(UitkContextWrapper, null, function (context) { return React.createElement(UitkButton, __assign({}, props, { className: cssClassNames, "data-context": context })); }));
    };
    UitkSecondaryButton.displayName = 'UitkSecondaryButton';
    return UitkSecondaryButton;
}(React.Component));

export { UitkSecondaryButton };
